import React, { useState } from "react";
import "./welcome-page.scss";
import CloudflareTurnstile from "../login/CloudflareTurnstile";
import { AppConfig } from "../../AppConfig";

type WelcomePageProps = {
  SurveyFormTitle?: string;
  SurveyFromInstructions?: string;
  setWelcomePageDemo?: React.Dispatch<React.SetStateAction<boolean>>;
  formType?: number;
  isPublicSurvey?: boolean;
};

const WelcomePage: React.FC<WelcomePageProps> = ({
  SurveyFormTitle,
  SurveyFromInstructions,
  setWelcomePageDemo,
  formType,
  isPublicSurvey = false,
}) => {
  // Verification is only required for public surveys when Cloudflare check is enabled
  const requiresVerification = Boolean(isPublicSurvey && AppConfig.CLOUDFLARE_CHECK);
  const [isVerified, setIsVerified] = useState<boolean>(!requiresVerification);

  const handleStartClick = () => {
    if (setWelcomePageDemo) {
      setWelcomePageDemo(true);
    }
  };

  return (
    <div className="welcome-page text-center">
      <h1>Welcome to your {formType === 2 ? "Quiz" : "Survey"}</h1>
      <p className="form-title"> {SurveyFormTitle}</p>
      <p> {SurveyFromInstructions}</p>
      <p className="mt-2">
        <i>
          {!requiresVerification || isVerified
            ? "We are glad you're here. Click \"Start\" to continue"
            : "Please complete the verification below to continue"}
        </i>
      </p>
      {requiresVerification && !isVerified ? (
        <div className="d-flex justify-content-center my-3">
          <CloudflareTurnstile
            size="normal"
            onVerify={(token) => {
              setIsVerified(true);
              if (token) {
                sessionStorage.setItem("turnstile_token", token);
              }
            }}
          />
        </div>
      ) : (
        <button onClick={handleStartClick} className="submit-btn">
          Start
        </button>
      )}
    </div>
  );
};

export default WelcomePage;
